export const inchesToCentimeters = (inches: number) => inches * 2.54;

export const poundsToKilograms = (pounds: number) => pounds * 0.453592;
